<template>
	<div>
		<div>
			<div class="searchHeader" ref="searchHeader">
				<el-form :model="searchData" label-width="80px">
					<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="5">
						<el-form-item label="课程名称">
							<el-input v-model="searchData.course_name" placeholder="请输入课程名称" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="5">
						<el-form-item label="资源名称">
							<el-input v-model="searchData.resource_name" placeholder="请输入资源名称" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col class="queryBtnLedger">
						<el-button type="primary" size="small" @click="queryData">查找</el-button>
						<el-button type="primary" size="small" @click="operation('删除多项', 'delMore')">删除多项</el-button>
<!--						<el-button type="primary" size="small" @click="operAudit('审核多项', 'auditMore')">审核多项</el-button>-->
					</el-col>
<!--					<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">-->
<!--						<el-form-item label="资源状态（单选）" label-width="135px">-->
<!--							<el-radio v-model="searchData.state" label="">全部</el-radio>-->
<!--							<el-radio v-model="searchData.state" :label="0">待审核</el-radio>-->
<!--							<el-radio v-model="searchData.state" :label="1">审核通过</el-radio>-->
<!--							<el-radio v-model="searchData.state" :label="2">审核不通过</el-radio>-->
<!--						</el-form-item>-->
<!--					</el-col>-->
<!--					<el-col :span="24">-->
<!--						<el-form-item label="资源类型（多选）" label-width="135px">-->
<!--							<el-checkbox-group v-model="searchData.resource_type">-->
<!--								<el-checkbox v-for="item in zylx" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>-->
<!--							</el-checkbox-group>-->
<!--						</el-form-item>-->
<!--					</el-col>-->
				</el-form>
			</div>
			<div class="tableDiy">
				<TableModule v-model="searchData" :columns="columns" class="tablePagination"
					:searchHeight="searchHeight" :url="url" ref="tablemodule" :initLoad="false">
					<template v-slot:sj="data">{{data.data.create_time | formats('YYYY-MM-DD') }}</template>
					<template v-slot:zyzt="data">
						<div @click="operation(data.data,'audit')" :class='data.data.apply_state | zySate | zySatestyle'>{{data.data.apply_state | zySate}}</div>
					</template>
					<template v-slot:view="data">
						<el-button @click="operation(data.data, 'view')" type="success" size="mini">查看</el-button>
					</template>
					<template v-slot:details="data">
						<el-button @click="clickZh(data.data)" v-if="data.data.resource_type == 6 || data.data.resource_type == 11"  type="success" size="mini">转化</el-button>
						<el-button @click="operation(data.data, 'del')" type="success" size="mini">删除</el-button>
						<el-button @click="operation(data.data, 'edi')" type="success" size="mini">编辑</el-button>
					</template>
				</TableModule>
			</div>
		</div>
		<div>
			<el-dialog
  title="提示"
  :visible.sync="dialogVisibleZh"
  width="30%"
  >
  <span v-if="bimface_id">此资源已经转化，是否确定再次转化?</span>
  <span v-else>是否确定转化?</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisibleZh = false">取 消</el-button>
    <el-button type="primary" @click="trueZh">确 定</el-button>
  </span>
</el-dialog>
		</div>
    <div>
      <el-dialog
        title="提示"
        :visible.sync="isAudit"
        width="30%"
      >
        <span>是否通过所选资源？</span>
        <span slot="footer" class="dialog-footer">
    <el-button @click="isAudit = false">取 消</el-button>
          <el-button type="primary" @click="auditTrue(2)">审核不通过</el-button>
    <el-button type="primary" @click="auditTrue(1)">审核通过</el-button>
  </span>
      </el-dialog>
    </div>
		<eldialog v-if="dialogData.dialogVisible" :dialogData='dialogData' @approvedClick = approvedClick :zylx="zylx"></eldialog>
	</div>
</template>

<script>

	//引入组件
  import eldialog from '@/views/testManagement/list/elDialog.vue'
	import TableModule from '@/views/testManagement/list/tableModule.vue'
	// import eldialog from './elDialog.vue'
	import filters from '@/api/filters.js' //局部引入过滤器
	export default {
    	filters:filters,
		components: {
			TableModule,
      eldialog
		},
		data() {
			return {
        isAudit:false, //多项审核弹框
				resourceIdZh:"", //转化资源id
				dialogVisibleZh:false, //转化弹框
				bimface_id:null, //bim ,cad资源类型的资源bimface_id如果没有值转化，如果有再次转化
				dialogData: { //弹出框存入数据
          data:{},
					dialogVisible: false,
					title: '',
				},
				searchHeight: '', //表格所占的高度
				url: {//页面所需要的数据地址
					table: this.$api.resourceList,
				},
				deletetData:{},//删除数据
				auditData:{},//审核数据
				searchData: {
					edit:false,
					resource_type:[4],//资源类型选中的值
				},//收集页面数据
				// zyzt: [
				// 	{id:'',name:'全部'},
				// 	{id:'0',name:'待审核'},
				// 	{id:'1',name:'审核通过'},
				// 	// {id:'2',name:'未通过审核'}
				// ], //资源状态
				zylx: [], //资源类型
				//表格的表头信息
				columns: [
					{
						type: 'selection',
						title: '序号',
						align: 'center',
					},
					{
						title: '资源ID',
						dataIndex: 'id',
						minWidth: '100px',
						align: 'center',
					},
					{
						title: '资源名称',
						dataIndex: 'name',
						minWidth: '200px',
						align: 'center',
					},
					{
						title: '所属课程',
						dataIndex: 'course_name',
						minWidth: '200px',
						align: 'center',
					},
					{
						title: '所属知识点',
						dataIndex: 'lore_name',
						minWidth: '200px',
						align: 'center',
					},
					{
						title: '作者',
						dataIndex: 'author',
						minWidth: '100px',
						align: 'center',
					},
					{
						title: '资源类型',
						dataIndex: 'resource_type_name',
						minWidth: '100px',
						align: 'center',
					},
					{
						title: '创建时间',
						dataIndex: 'create_time',
						minWidth: '100px',
						align: 'center',
						slot: 'sj',
					},
					{
						title: '查看',
						minWidth: '100px',
						slot: 'view',
						align: 'center',
					},
					// {
					// 	title: '资源状态',
					// 	dataIndex: 'apply_state',
					// 	minWidth: '100px',
					// 	slot: 'zyzt',
					// 	align: 'center',
					// },
					{
						minWidth: '220px',
						title: '操作',
						slot: 'details',
						align: 'center',
					},
				],
			};
		},

		methods: {
			//点击转化
			clickZh(v){
				this.resourceIdZh= v.id
				// console.log(v)
				let json = {
						resource_id:v.id,
						resource_type:v.resource_type,
					}
					this.$get(this.$api.resourceDetails,json).then(res => {
						console.log(res)
						if(res.code === 0){
							this.bimface_id = res.ret.details.bimface_id
							this.dialogVisibleZh = true
						}
					})
			},
			//确认转化
			trueZh(){
				let data ={
					resource_id:this.resourceIdZh
				}
               this.$post(this.$api.resourceTranslate,data).then(res => {
						console.log(res)
						if(res.code === 0){
							this.$message.success("成功")
							this.dialogVisibleZh = false
						}

					})
			},
			//页面加载渲染表格
			queryData() {
				this.$nextTick(() => {
					this.$refs.tablemodule.Tablemodule();
					this.$refs.tablemodule.$children[0].clearSort();
				})
			},
			//初始化--获取资源状态
			init(){
				this.$get(this.$api.getresourcetype).then(res => {
					if(res.code === 0){
						this.zylx = res.ret
					}
				})
			},
			//多选审核资源列表数据
			operAudit(data, el){
				// resourceAudit
				let audData = []//审核数据
				if(this.$refs.tablemodule.dxData.length <= 0 && el === 'auditMore'){
					this.$message.error('请先选择需要批量审核的数据！');
				}else{
				  this.isAudit =  true
					// this.$confirm('您确定审核该资源吗?').then(_ => {
          // this.auditTrue()
					// })
				}
			},
      //多选审核
      auditTrue(v){
        let audData = []//审核数据
        this.$refs.tablemodule.dxData.forEach(item => {
          let json = {}
          json['resource_id'] = item.id
          audData.push(json)
        })
        this.auditData['value_array'] = audData
        if(v == 1){
          this.auditData['apply_state'] = '1'
        }else if(v ==2){
          this.auditData['apply_state'] = '2'
        }

        this.$post(this.$api.resourceAudit,this.auditData).then(res => {
          if(res.code === 0){
            this.isAudit =  false
            this.$message.success('审核成功');
            this.queryData()
          }
        })
      },
			//弹框返回的值 审核通过or不通过
			approvedClick(data){
				if(data == false){
					this.queryData()
					this.dialogData.dialogVisible = false
				}else{
					let audData = []//审核数据
					let json = {
						resource_id:this.dialogData.data.details.id
					}
					audData.push(json)
					this.auditData['value_array'] = audData
					if(data === 'yes'){
						this.auditData['apply_state'] = '1'
					}else{
						this.auditData['apply_state'] = '2'
					}
					this.$post(this.$api.resourceAudit,this.auditData).then(res => {
						if(res.code === 0){
							this.dialogData.dialogVisible = false
							this.$message.success('操作成功');
							this.queryData()
						}
					})
				}
			},
			//操作方法
			operation(data, el) {
				// this.$refs.tablemodule.dxData 拿取表格多选的数据
				//删除方法or编辑or查看
				let delData = []//删除数据
				if (el === 'del' || el === 'delMore') {
					if(this.$refs.tablemodule.dxData.length <= 0 && el === 'delMore'){
						this.$message.error('请先选择需要批量删除的数据！');
					}else{
						this.$confirm('您确定删除该资源吗?')
						.then(_ => {
							if(el === 'del'){
								let json = {}
								json['resource_id'] = data.id
								delData.push(json)
								this.deletetData['value_array'] = delData
							}else{
								this.$refs.tablemodule.dxData.forEach(item => {
									let json = {}
									json['resource_id'] = item.id
									delData.push(json)
								})
								this.deletetData['value_array'] = delData
							}
							this.$post(this.$api.resourceDeletet,this.deletetData).then(res => {
								if(res.code === 0){
									this.$message.success('删除成功');
									this.queryData()
								}
							})
						})
					}

				} else {
					let json = {
						resource_id:data.id,
						resource_type:data.resource_type,
					}
					this.$get(this.$api.resourceDetails,json).then(res => {
						console.log(res)
						if(res.code === 0){
							if(res.ret.details){
								this.dialogData.data = res.ret
							}else{
								this.dialogData.data = {}
							}
							if(res.ret.details && res.ret.details.options && el !== 'edi'){
								res.ret.details['options'] = JSON.parse(res.ret.details.options)
								console.log(res)
								let zmData = []
								res.ret.details.options.forEach(item =>{
									let zm = this.$options.filters.change(Number(item.number))
									item.zmb = zm
									if(item.answer === 1){
										zmData.push(item.zmb)
									}
								})
								res.ret.details['answer'] = zmData.join(',')
							}
							this.dialogData.dialogVisible = true
							this.dialogData.edit = false
							if (el === 'edi') {
								this.dialogData.edit = true
								this.dialogData.title = '编辑试题'
                // this.dialogData.title = '编辑--资源'
								this.dialogData.width = '80%'
							}else if(el === 'audit'){
								this.dialogData.title = '审核'
							}else{
							 	this.dialogData.title = '查看'
							}
						}
					})
				}
			}
		},
		created (){
		},
		mounted(){
			this.init()
            this.searchHeight = this.$refs.searchHeader.offsetHeight;
		},
		watch:{
			searchData:{
				handler(nerVal) {
					this.queryData()
				},
				deep: true,
				immediate: true,
			}
		}
	}
</script>

<style scoped>

</style>
